import React from 'react';
import styles from './SignInHeader.module.css';

function SignInHeader(props) {


  return (<span className={styles.codeWasSent}>
            <span>
             {props.children}

            </span>
    {props.phone && <span>
            {props.phone}
            </span>}
          </span>);
}


export default SignInHeader;
